  <div
          class="gap-6 sm:h-fit lg:h-full sm:min-h-12 flex-col sm:w-full   p-5 bg-[#252A30] main-container">
          <div>
            <span class="md:text-lg sm:text-base font-medium text-[#F7FFF7]">
              {{ "environment_benefits" | translate }}</span>
          </div>
          <div class="flex-grow flex justify-center  sm:items-center lg:items-start w-full sm:pb-2">
            <div class="flex flex-row md:flex-col sm:w-full justify-between md:w-full xl:w-full xl:justify-between">
              <!--1st-->
              <div class="flex sm:flex-col md:flex-row sm:items-start md:items-center">
                <div class="sm:pl-1 md:pl-0">
                  <img src="../../../../../assets/svg/equivalent_trees_planted.svg"
                    class="sm:w-8 sm:h-8 md:w-[3.022rem] md:h-[3.022rem]  lg:w-[2.3125rem] lg:h-[2.3125rem]  "
                    alt="Tree" alt="tree" />
                </div>
                <div class="sm:flex-col md:flex-row flex   ml-2 md:gap-0 md:-mt-1 ">
                  <div class=" mt-[3.9px]" >
                    <span
                      class="md:font-medium md:h-[1.4375rem] sm:font-normal  sm:h-[1.1rem] leading-[100%] text-lg text-[#EBEAEB]">{{
                      equivalentTreesPlanted }}</span>
                  </div>
                  <div class="sm:mt-0.7 md:mt-unset md:ml-2  ">
                    <span class="sm:text-sm md:text-base font-normal mt-1 text-[#AEAEAE] tracking-[2%]">{{
                      "equivalent_trees_planted" | translate }}</span>
                  </div>
                </div>
              </div>
              <!--2nd-->
              <div class="flex  sm:flex-col md:flex-row sm:items-start md:items-center md:mt-2.5">
                <div class="sm:pl-1 md:pl-0">
                  <img src="../../../../../assets/svg/co2_emission_saved.svg"
                    class="sm:w-8 sm:h-8 md:w-[3.022rem] md:h-[3.022rem] lg:w-[2.3125rem] lg:h-[2.3125rem]  " alt="Tree"
                    alt="tree" />
                </div>
                <div class="sm:flex-col flex md:flex-row  ml-2 md:gap-0 md:-mt-1 ">
                  <div  class=" mt-[3.9px]">
                    <span
                      class="md:font-medium sm:font-normal md:h-[1.4375rem] sm:h-[1.1rem] text-nowrap leading-[100%] text-lg text-[#EBEAEB]">{{
                      co2EmissionSaved }}</span>
                  </div>
                  <div class="sm:mt-0.7 md:mt-0 md:ml-2">
                    <span class="sm:text-sm md:text-base font-normal mt-1 text-[#AEAEAE] tracking-[2%]">{{
                      "co2_emission_saved" | translate }}
                    </span>
                  </div>
                </div>
              </div>
              <!--3-->
              <div class="flex sm:items-start md:items-center  sm:flex-col md:flex-row md:mt-2.5">
                <div class="sm:pl-1 md:pl-0">
                  <img src="../../../../../assets/svg/coal_not_burnt.svg"
                    class="sm:w-8 sm:h-8 md:w-[3.022rem] md:h-[3.022rem] lg:w-[2.3125rem] lg:h-[2.3125rem]  " alt="Tree"
                    alt="tree" />
                </div>
                <div class="sm:flex-col flex md:flex-row ml-2 md:gap-0 md:-mt-1">
                  <div class=" mt-[3.9px]">
                    <span
                      class="md:font-medium sm:font-normal md:h-[1.4375rem] text-nowrap sm:h-[1.1rem] leading-[100%] text-lg text-[#EBEAEB]">{{
                    coalNotBurned }}
                    </span>
                  </div>
                  <div class="sm:mt-0.7 md:mt-0 md:ml-2">
                    <span class="sm:text-sm md:text-base font-normal mt-1 text-[#AEAEAE] tracking-[2%]">{{ "coal_not_burned"
                      | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
